import React from 'react';

export type NumberedListVariant = 'gradient' | 'indigo' | 'muted';

const VARIANTS: Record<NumberedListVariant, { list: string; item: string; badge: string; text: string; badgeStyle?: React.CSSProperties }> = {
  /** Quick Start — ตัวเลขไล่สีตามธีม */
  gradient: {
    list: 'space-y-3',
    item: 'flex items-center gap-3 group',
    badge: 'w-7 h-7 rounded-lg text-white text-xs flex items-center justify-center font-bold shrink-0 shadow-md',
    text: 'text-gray-700 dark:text-slate-200 text-sm group-hover:text-gray-900 dark:group-hover:text-white transition-colors',
    badgeStyle: { background: 'var(--theme-primary-gradient)' },
  },
  /** ขั้นตอนเชิงเทคนิค (เช่นวิธีสร้าง signature) */
  indigo: {
    list: 'space-y-3',
    item: 'flex items-start gap-3',
    badge: 'w-6 h-6 rounded-lg bg-indigo-500 text-white text-xs flex items-center justify-center font-bold shrink-0 mt-0.5',
    text: 'text-gray-700 dark:text-slate-200 text-sm',
  },
  /** ขั้นตอนตั้งค่าทั่วไป */
  muted: {
    list: 'space-y-2.5',
    item: 'flex items-center gap-3',
    badge: 'w-6 h-6 rounded-lg bg-gray-200 dark:bg-slate-600 text-gray-600 dark:text-slate-200 text-xs flex items-center justify-center font-bold shrink-0',
    text: 'text-gray-700 dark:text-slate-200 text-sm',
  },
};

/** รายการแบบมีตัวเลขนำหน้า — ใช้ซ้ำใน Overview / Authentication / Webhooks */
const NumberedList: React.FC<{
  items: React.ReactNode[];
  variant?: NumberedListVariant;
  className?: string;
}> = ({ items, variant = 'gradient', className = '' }) => {
  const v = VARIANTS[variant];
  return (
    <ol className={`${v.list} ${className}`.trim()}>
      {items.map((item, idx) => (
        <li key={idx} className={v.item}>
          <span className={v.badge} style={v.badgeStyle}>{idx + 1}</span>
          <span className={v.text}>{item}</span>
        </li>
      ))}
    </ol>
  );
};

export default NumberedList;
